import React, {useCallback, useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {MobileCarrierStartPaymentInfo} from '../../../DTO/MobileCarrierStartPaymentInfoDTO'

type LocationState = {
  mobileCarrierStartPaymentInfo: MobileCarrierStartPaymentInfo
}
export const MembersMobileCarrierTransitionPage: React.VFC = () => {
  const location = useLocation<LocationState>()
  const locationState: LocationState = location.state

  const {startURL, accessID, token} = locationState.mobileCarrierStartPaymentInfo

  const form = document.createElement('form')

  useEffect(() => {
    form.action = startURL
    form.method = 'POST'
    form.setAttribute('data-testid', 'form-post-carrier-payment-info')

    form.innerHTML = `<input type=hidden name=AccessID value=${accessID} data-testid=input-access-id> <input type=hidden name=Token value=${token} data-testid=input-token>`

    document.body.append(form)

    postMobileCarrierPaymentInfo()
  }, [form, locationState.mobileCarrierStartPaymentInfo])

  const postMobileCarrierPaymentInfo = useCallback((): void => {
    form.submit()
  }, [])


  return null
}
